(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["symbols-meanings-atlas"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-symbols-atlas]');

    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const cards = [...root.querySelectorAll('[data-symbol-card]')];
      const search = root.querySelector('[data-symbol-search]');
      const clear = root.querySelector('[data-symbol-clear]');
      const count = root.querySelector('[data-symbol-count]');
      const empty = root.querySelector('[data-symbol-empty]');
      const dialog = root.querySelector('[data-symbol-dialog]');
      const cultureButtons = [...root.querySelectorAll('[data-symbol-filters="culture"] button')];
      const intentButtons = [...root.querySelectorAll('[data-symbol-filters="intent"] button')];
      let culture = 'all';
      let intent = 'all';

      const applyFilters = () => {
        const query = search.value.trim().toLowerCase();
        let visible = 0;

        cards.forEach((card) => {
          const cultureMatches = culture === 'all' || card.dataset.culture === culture;
          const intentMatches = intent === 'all' || card.dataset.intents.split(',').map((value) => value.trim()).includes(intent);
          const searchMatches = !query || card.dataset.search.includes(query);
          const show = cultureMatches && intentMatches && searchMatches;
          card.hidden = !show;
          if (show) visible += 1;
        });

        count.textContent = visible;
        empty.hidden = visible !== 0;
        clear.hidden = query.length === 0;
      };

      const bindFilterGroup = (buttons, type) => {
        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            buttons.forEach((item) => {
              const active = item === button;
              item.classList.toggle('is-active', active);
              item.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
            if (type === 'culture') culture = button.dataset.filterValue;
            if (type === 'intent') intent = button.dataset.filterValue;
            applyFilters();
          });
        });
      };

      bindFilterGroup(cultureButtons, 'culture');
      bindFilterGroup(intentButtons, 'intent');
      search.addEventListener('input', applyFilters);
      clear.addEventListener('click', () => {
        search.value = '';
        search.focus();
        applyFilters();
      });

      cards.forEach((card) => {
        card.querySelector('[data-symbol-open]').addEventListener('click', () => {
          const data = card.querySelector('.symbols-atlas__dialog-data');
          dialog.querySelector('[data-dialog-art]').innerHTML = card.querySelector('.symbols-atlas__icon').innerHTML;
          dialog.querySelector('[data-dialog-title-output]').textContent = data.querySelector('[data-dialog-title]').textContent;
          dialog.querySelector('[data-dialog-culture-output]').textContent = data.querySelector('[data-dialog-culture]').textContent;
          dialog.querySelector('[data-dialog-meaning-output]').textContent = data.querySelector('[data-dialog-meaning]').textContent;
          dialog.querySelector('[data-dialog-status-output]').textContent = data.querySelector('[data-dialog-status]').textContent;
          dialog.querySelector('[data-dialog-summary-output]').textContent = data.querySelector('[data-dialog-summary]').textContent;
          dialog.querySelector('[data-dialog-link]').href = data.querySelector('[data-dialog-url]').textContent || '/blogs/blog';
          dialog.showModal();
        });
      });

      dialog.querySelector('[data-symbol-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
